module.exports = __webpack_public_path__ + "img/6.39d874c8.jpg";